import { render, staticRenderFns } from "./SVG.vue?vue&type=template&id=08a5c5d8&scoped=true&"
import script from "./SVG.vue?vue&type=script&lang=js&"
export * from "./SVG.vue?vue&type=script&lang=js&"
import style0 from "./SVG.vue?vue&type=style&index=0&id=08a5c5d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a5c5d8",
  null
  
)

export default component.exports